import { createDerivedWritableAtom } from '../../utils';
import { type ConsentStatus, type ConsentUpdateSource, WritableDataChannelAtom } from '../../video-sdk';
import { dataChannelAppStateAtom } from '../../video-sdk/core/message/atoms';
import { createDataChannelPropertyAtom } from '../../video-sdk/core/message/utils';

const providerAtom = createDerivedWritableAtom(dataChannelAppStateAtom, 'provider');

export const providerConsentAtom: WritableDataChannelAtom<ConsentStatus> = createDataChannelPropertyAtom(
  providerAtom,
  'consent',
);

const patientAtom = createDerivedWritableAtom(dataChannelAppStateAtom, 'patient');

export const patientConsentAtom: WritableDataChannelAtom<ConsentStatus> = createDataChannelPropertyAtom(
  patientAtom,
  'consent',
);

export const patientConsentUpdateSourceAtom: WritableDataChannelAtom<ConsentUpdateSource> =
  createDataChannelPropertyAtom(patientAtom, 'updateSource');
